import { Pipe, PipeTransform } from '@angular/core';

/**
 * OrderBy Pipe
 * Orders an array of objects by one or more properties.
 * 
 * Usage: 
 *   - Single property: *ngFor="let item of items | orderBy:'property'"
 *   - Multiple properties: *ngFor="let item of items | orderBy:['prop1', 'prop2']"
 *   - Descending: *ngFor="let item of items | orderBy:'-property'"
 * 
 * Example: *ngFor="let line of groupedFormLines | orderBy:['LINE_ORDER', 'SNO']"
 */
@Pipe({
    name: 'orderBy',
    pure: false,
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  transform(items: any[], orderBy: string | string[]): any[] {
    if (!items || !orderBy) {
      return items;
    }

    // Convert to array if single property
    const properties = Array.isArray(orderBy) ? orderBy : [orderBy];
    
    // Create a copy to avoid mutating original array
    const sortedItems = [...items];

    return sortedItems.sort((a, b) => {
      for (const prop of properties) {
        // Check for descending order (prefix with -)
        const isDescending = prop.startsWith('-');
        const actualProp = isDescending ? prop.substring(1) : prop;
        
        const valueA = a[actualProp];
        const valueB = b[actualProp];

        // Handle null/undefined
        if (valueA === null || valueA === undefined) {
          return isDescending ? -1 : 1;
        }
        if (valueB === null || valueB === undefined) {
          return isDescending ? 1 : -1;
        }

        // Compare values
        let comparison = 0;
        if (typeof valueA === 'number' && typeof valueB === 'number') {
          comparison = valueA - valueB;
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          comparison = valueA.localeCompare(valueB);
        } else {
          comparison = String(valueA).localeCompare(String(valueB));
        }

        // If not equal, return the comparison result
        if (comparison !== 0) {
          return isDescending ? -comparison : comparison;
        }
      }
      
      return 0;
    });
  }
}
